import { Row, Table, TableProps, Typography } from "antd";
import "./PipelineDetails.scss";
import React from "react";
import { utilityService } from "shared/services";
import { getPipelineDetailsColumns } from "sales/constants";
import { useBoundStore } from "store";
import { IPipelineDetails } from "sales/models";

interface PipelineDetailsProps {
  pipelineDetails: IPipelineDetails[];
}

export const PipelineDetails = ({ pipelineDetails }: PipelineDetailsProps) => {
  const { currentOrganization } = useBoundStore();
  const tblRef: Parameters<typeof Table>[0]["ref"] = React.useRef(null);
  const tableColumns = getPipelineDetailsColumns(currentOrganization);
  const tableProps: TableProps<IPipelineDetails> = {};

  return (
    <div data-testid='pipelineDetails'>
      <Row>
        <Typography.Title className='pipeline-details-title' level={3}>
          Pipeline Details
        </Typography.Title>
      </Row>
      <Row>
        <Table
          {...tableProps}
          columns={tableColumns}
          dataSource={pipelineDetails}
          className='pipeline-details-table'
          ref={tblRef}
          rowKey='id'
          pagination={false}
          summary={(pageData) => {
            let totalCommission = 0;
            let totalRevenue = 0;

            pageData.forEach(({ commission, revenue }) => {
              totalRevenue += Number(revenue);
              totalCommission += Number(commission);
            });

            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <Typography.Text strong>TOTALS</Typography.Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>
                    <Typography.Text strong>
                      ${utilityService.statisticsFormatter(totalRevenue)}
                    </Typography.Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>
                    <Typography.Text strong>
                      ${utilityService.statisticsFormatter(totalCommission)}
                    </Typography.Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </Row>
    </div>
  );
};
